export const routes = (prefix = `theatre`) => [
    {
        path: `/${prefix}/previous-procedures`,
        name: `${prefix}.previous-procedures.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.previous-procedures.index`,
                PageDescription: "Theatre: Previous Procedures",
            },
        },
    },
    {
        path: `/${prefix}/previous-procedures-print`,
        name: `${prefix}.previous-procedures-print.index`,
        component: () => import('./prints/CompletedProcedures.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.previous-procedures.index`,
                PageDescription: "Theatre: Previous Procedures",
            },
        },
    },
    {
        path: `/${prefix}/previous-procedures-details-print`,
        name: `${prefix}.previous-procedures-details-print.index`,
        component: () => import('./prints/ProcedureDetails.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.previous-procedures.index`,
                PageDescription: "Theatre: Previous Procedures",
            },
        },
    },
];
